import { render } from "./SingleEvent.vue?vue&type=template&id=e8cb49ce"
import script from "./SingleEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleEvent.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/sarahmarinoff/Sites/fc2025/wp-content/plugins/baytek-portal-helper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/SingleEvent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e8cb49ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e8cb49ce', __exports__)) {
    console.log('reload')
    api.reload('e8cb49ce', __exports__)
  }
  
  module.hot.accept("./SingleEvent.vue?vue&type=template&id=e8cb49ce", () => {
    console.log('re-render')
    api.rerender('e8cb49ce', render)
  })

}


export default __exports__